import styled from 'styled-components';

import { gridSizes, media } from 'utils/style';

import Header from 'components/ModalCancelOrder/Sections/Header/container';

export default styled(Header)`
  padding: 20px ${gridSizes('L')} 12px;
  border-bottom: solid 1px var(--grey-mouse);
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${media.lessThan('extraSmall')`
          background: var(--white);
          padding: ${gridSizes('M')};
          padding-top: 12px !important;
          padding-bottom: 12px !important;
          flex-direction: row-reverse;
          border-radius: 2px;
      `};

  .info {
    flex: 1;
    flex-direction: column;
    display: flex;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    h2 {
      margin: 0;
    }
  }

  .close {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;

    padding: ${gridSizes('S')};

    cursor: pointer;
    display: flex;
    flex-direction: column;

    ${media.lessThan('extraSmall')`
      margin: inherit;
      justify-content: center;
      align-items: center;
      `};
  }
`;
